import gql from 'graphql-tag';

export const RECALCULATE_SERVICE_RUN_PICKLISTS = gql`
	mutation recalculateServiceRunPicklists (
		$serviceRunId: ID!,
		$mode: PickListRecalculationMode,
	) {
		recalculateServiceRunPicklists (
			serviceRunId: $serviceRunId,
			mode: $mode,
		) {
			id
			calculatedAt
			pickListItems {
				id
				isPicked
				planogramItem {
					id
					selection
					quantity
					parlevel
					price
					reportedPrice
					enabled
					isIngredient
					row
					column
					planogramItemGroupId
					created
				}
				selection

				quantity
				extraQuantity
				extraQuantityIsPicked
				unadjustedQuantity

				planogramItemQuantity
				planogramItemParlevel
				planogramItemExpiryDatesAtPick

				originalPickQuantity
				originalPlanogramItemQuantity
				originalPickExtraQuantity
				lastCalculatedExtraQuantity

				product {
					id
					name
					imageUrl
					HCGCategory
					HFDCategory
					measurementUnit
				}
				removedProduct {
					id
					name
					imageUrl
				}
			}
		}
	}
`;
